"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("@folio/stripes/components");
var _IconSelect = _interopRequireDefault(require("../../../styles/IconSelect.css"));
var _RichSelect = _interopRequireWildcard(require("../RichSelect"));
var _FormattedKintMessage = _interopRequireDefault(require("../FormattedKintMessage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// A form component which acts as a "Select for states with corresponding icons"
const IconSelect = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    ariaLabel,
    disabled = false,
    id,
    input,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    label,
    meta,
    notSet,
    onChange,
    options: userOptions = [],
    required = false,
    value
  } = _ref;
  const defaultNotSet = {
    icon: 'ellipsis',
    value: '',
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedKintMessage.default, {
      id: "notSet",
      intlKey: passedIntlKey,
      intlNS: passedIntlNS
    })
  };

  // Options with notSet
  const options = [notSet ?? defaultNotSet, ...userOptions];
  const [richSelectRef, selectedOption] = (0, _RichSelect.useSelectedOption)();
  (0, _react.useImperativeHandle)(ref, () => ({
    selectedOption
  }));
  const {
    className: iconButtonClassName,
    ...buttonProps
  } = selectedOption?.buttonProps ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RichSelect.default, {
    ref: richSelectRef,
    ariaLabel: ariaLabel,
    disabled: disabled,
    id: id,
    input: input,
    label: label,
    meta: meta,
    onChange: onChange,
    options: options,
    renderOption: opt => {
      if (opt.icon) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Icon, {
          icon: opt.icon,
          ...opt.iconProps,
          children: opt.label ?? opt.value
        });
      }
      return opt.label ?? opt.value;
    },
    renderTrigger: _ref2 => {
      let {
        onToggle,
        triggerRef,
        keyHandler,
        ariaProps,
        getTriggerProps
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        ref: triggerRef,
        disabled: disabled,
        icon: selectedOption?.icon ?? 'ellipsis',
        marginBottom0: true,
        onClick: onToggle,
        onKeyDown: keyHandler,
        type: "button",
        className: (0, _classnames.default)(_IconSelect.default.buttonStyle, iconButtonClassName),
        ...buttonProps,
        ...getTriggerProps(),
        ...ariaProps
      });
    },
    required: required,
    value: value
  });
});
IconSelect.propTypes = {
  ariaLabel: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  input: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.node]),
  meta: _propTypes.default.object,
  notSet: _propTypes.default.shape({
    icon: _propTypes.default.string,
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
  }),
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
  })),
  required: _propTypes.default.bool,
  value: _propTypes.default.string
};
var _default = exports.default = IconSelect;